// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput
} from '@mui/material'


import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import { useNavigate, useParams } from "react-router-dom";

import Icon from '../../../../components/icon';
import MsiDatagridDynamic from '../../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../../configs/constant';

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();

    // ** State
    const [tabs, setTabs] = useState<string>("0")
    const [listRole, setListRole] = useState<any[]>([])

    const [mode, setMode] = useState<string>("detail")

    const [showPassword, setShowPassword] = useState<boolean>(false)

    useEffect(() => {
        getData()
    }, [])

    const getData = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/system/user/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setValue('nama', data.nama)
                    setValue('email', data.email)
                    setValue('keterangan', data.keterangan)
                    setValue('password', data.password)
                    setValue('hp', data.hp)

                    getRoleById(data.role)

                    // setValue('username', data.username)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getRoleById = (role: any) => {
        const url = apiUrl.apiUrl + '/system/role/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.nama === role) {
                            setValue('sysrole_id', element.id)
                        }
                    });
                    setListRole(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const navigate = useNavigate();

    interface FormInputs {
        nama: any,
        keterangan: any,
        hp: any,
        email: any,
        password: any,
        password_confirmation: any,
        sysrole_id: any,
        syscabang_id: any
    }

    const defaultValues = {
        syscabang_id: cabang
    }

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })


    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                let url = ''
                if (mode === 'detail') {
                    url = apiUrl.apiUrl + '/system/user/edit/' + id
                } else if (mode === 'password') {
                    url = apiUrl.apiUrl + '/system/user/change-password/' + id
                } else if (mode === 'role') {
                    url = apiUrl.apiUrl + '/system/user/change-role/' + id
                }

                axios
                    .put(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/setting/user')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                        <Typography variant='h5' sx={{ textAlign: 'center' }}>
                            Detail User
                        </Typography>
                        <br />
                        <Divider sx={{ m: 0 }} />
                        <TabContext value={tabs}>
                            <TabList
                                scrollButtons
                                variant='scrollable'
                                onChange={handleChangeTabs}
                                aria-label='centered tabs'
                                sx={{
                                    my: 3,
                                    justifyContent: 'center', // center horizontal
                                    display: 'flex',
                                    gap: 2 // jarak antar tab
                                }}
                            >
                                <Tab
                                    value='0'
                                    label='DETAIL'
                                    icon={<Icon icon={"mdi:account-cog"} />}
                                    sx={{ minWidth: 'fit-content', flex: 1 }}
                                />
                                <Tab
                                    value='1'
                                    label='RUBAH PASSWORD'
                                    icon={<Icon icon={"mdi:account-key"} />}
                                    sx={{ minWidth: 'fit-content', flex: 1 }}
                                />
                                <Tab
                                    value='2'
                                    label='RUBAH ROLE'
                                    icon={<Icon icon={"mdi:account-sync"} />}
                                    sx={{ minWidth: 'fit-content', flex: 1 }}
                                />
                            </TabList>
                            <TabPanel value='0'>
                                <Grid container spacing={3} sx={{ mt: -5 }}>
                                    <Grid item xs={12} sm={6}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Nama
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='nama'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Nama'
                                                        error={Boolean(errors.nama)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.nama && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            No. HP
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='hp'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='No. HP'
                                                        type='number'
                                                        error={Boolean(errors.hp)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.hp && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Email
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='email'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Email'
                                                        type='email'
                                                        error={Boolean(errors.email)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.email && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Keterangan
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='keterangan'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Keterangan'
                                                        rows={2}
                                                        multiline
                                                        error={Boolean(errors.keterangan)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.keterangan && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Box
                                            sx={{
                                                width: '100%',
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                                <Button variant='contained' type='submit' onClick={() => setMode('detail')}
                                                >
                                                    SIMPAN
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </TabPanel>
                            <TabPanel value='1'>
                                <Grid container spacing={3} sx={{ mt: -5 }}>
                                    <Grid item xs={12} sm={6}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            New Password
                                        </Typography>
                                        <FormControl fullWidth>
                                            <InputLabel htmlFor='auth-login-v2-password' error={Boolean(errors.password)}>
                                                New Password
                                            </InputLabel>
                                            <Controller
                                                name='password'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange, onBlur } }) => (
                                                    <OutlinedInput
                                                        value={value}
                                                        onBlur={onBlur}
                                                        label='New Password'
                                                        onChange={onChange}
                                                        id='auth-login-v2-password'
                                                        type={showPassword ? 'text' : 'password'}
                                                        endAdornment={
                                                            <InputAdornment position='end'>
                                                                <IconButton
                                                                    edge='end'
                                                                    onMouseDown={e => e.preventDefault()}
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                >
                                                                    <Icon icon={showPassword ? 'mdi:eye-outline' : 'mdi:eye-off-outline'} fontSize={20} />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                    />
                                                )}
                                            />
                                            {errors.password && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Password Confirmation
                                        </Typography>
                                        <FormControl fullWidth>
                                            <InputLabel htmlFor='auth-login-v2-password' error={Boolean(errors.password)}>
                                                Password Confirmation
                                            </InputLabel>
                                            <Controller
                                                name='password_confirmation'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange, onBlur } }) => (
                                                    <OutlinedInput
                                                        value={value}
                                                        onBlur={onBlur}
                                                        label='Password Confirmation'
                                                        onChange={onChange}
                                                        id='auth-login-v2-password'
                                                        type={showPassword ? 'text' : 'password'}
                                                        endAdornment={
                                                            <InputAdornment position='end'>
                                                                <IconButton
                                                                    edge='end'
                                                                    onMouseDown={e => e.preventDefault()}
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                >
                                                                    <Icon icon={showPassword ? 'mdi:eye-outline' : 'mdi:eye-off-outline'} fontSize={20} />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                    />
                                                )}
                                            />
                                            {errors.password_confirmation && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Typography variant='caption' sx={{ color: 'red', mb: 1, mt: 1 }}>
                                            <i>*Password minimal 8 karakter</i>
                                        </Typography>
                                        <Box
                                            sx={{
                                                width: '100%',
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                                <Button variant='contained' type='submit' onClick={() => setMode('password')}>
                                                    SIMPAN
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </TabPanel>
                            <TabPanel value='2'>
                                <Grid container spacing={3} sx={{ mt: -5 }}>
                                    <Grid item xs={12} sm={6}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Role User
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='sysrole_id'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <>
                                                        <InputLabel id='select-role'>Role User</InputLabel>
                                                        <Select
                                                            label='Role User'
                                                            value={value}
                                                            onChange={onChange}
                                                            id='select-role'
                                                            labelId='select-role'
                                                        >
                                                            {listRole.map((item: any) => (
                                                                <MenuItem key={item.id} value={item.id}>
                                                                    {item.nama}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </>
                                                )}
                                            />
                                            {errors.sysrole_id && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Box
                                            sx={{
                                                width: '100%',
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                                <Button variant='contained' type='submit' onClick={() => setMode('role')}>
                                                    SIMPAN
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>

                            </TabPanel>
                        </TabContext>
                    </div>
                </form>
            </Grid>

        </Grid>
    )
}
